import axios from "axios";
import { autocompleteVacationRentalsPath } from "../paths";

import { config } from "../../config";
import { ICategorizedResponse, Category, IdEnum } from "redmond";

interface VRAutocompleteResult {
  placeId: string;
  label: string;
}

export const fetchVRLocationAutocomplete = (
  query: string,
  locale = "en_US",
  limit = 10
): Promise<{ categories: ICategorizedResponse[] }> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(
        autocompleteVacationRentalsPath,
        { query, locale, limit },
        { baseURL: config.baseURL }
      );

      const results: VRAutocompleteResult[] = res.data.results || [];

      resolve({
        categories: [
          {
            category: Category.Places,
            label: "Vacation Rentals",
            results: results.map((item) => ({
              id: {
                Id: IdEnum.Lodgings,
                lodgingSelection: {
                  searchTerm: query,
                  placeId: item.placeId,
                },
              },
              label: item.label,
            })),
          },
        ],
      });
    } catch (e) {
      reject(e);
    }
  });
